module.exports = __webpack_public_path__ + "media/images/how-we-test__header-ecea023291f99152401fe68f7e046f0b.jpg";